import { render, staticRenderFns } from "./login-new.vue?vue&type=template&id=4c7830a8&scoped=true"
import script from "./login-new.vue?vue&type=script&lang=js"
export * from "./login-new.vue?vue&type=script&lang=js"
import style0 from "./login-new.vue?vue&type=style&index=0&id=4c7830a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7830a8",
  null
  
)

export default component.exports